<template>
  <div id="server" @click="serverClick()"></div>
</template>

<script>
export default {
  methods: {
    serverClick () {
      this.YSF.init('1a5d46871ba2e8c628b5a7abe265ef26', {
        templateId: 123, // templateId表示自定义会话邀请的模板标识
        shuntId: 123, // shuntId表示访客选择多入口分流模版id
        sessionInvite: false, // sessionInvite表示是否开启会话邀请设置
        hidden: 1 // hidden表示是否隐藏访客端默认入口
      }).then(ysf => {
        ysf('open')
        // ysf('product', {
        //     show: 1,
        //     title: '任天堂（Nintendo）Switch游戏机',
        //     desc: '任天堂（Nintendo） Switch NS NX掌上游戏机便携 塞尔达马里奥新款游戏机 主机不锁 日版黑机彩色手柄+中文赛/塞尔达传说(指南+地图)',
        //     picture: 'https://img10.360buyimg.com/n5/s75x75_jfs/t4030/290/29851193/293745/d5e2b731/58ac3506Nbb57b5f6.jpg',
        //     note: '￥1978',
        //     url: 'https://www.taobao.com/',
        //     sendByUser: 0
        // })
      }).catch(error => {
        console.log(error)
        console.log('sdk加载失败')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#server{
  position: fixed;
  right: 15px;
  bottom: 40px;
  width: 35px;
  height: 35px;
  background: url('../images/kf.png')no-repeat center center;
  background-size: cover;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/view/introduce/component/server.vue